import { useEffect } from 'react';
import classNames from 'classnames/bind';
import styles from './Feedback.module.css';
import { useNavigate } from 'react-router-dom';

import {
  settingsApiSlice,
  useGetFeedbackQuery,
} from '../../../services/settings';

import {
  FEEDBACK,
  FEEDBACK_GUIDE,
  NO_FEEDBACK,
  WRITING_FEEDBACK,
} from '../../../constants';
import TableBody from '../../../components/TableBody/TableBody';

import { useAppDispatch, useAppSelector } from '../../../hooks/useRedux';
import {
  feedbackPageChanged,
  selectFeedbackPage,
} from '../../../features/settingsSlice';

export default function Feedback() {
  const cx = classNames.bind(styles);
  const dispatch = useAppDispatch();
  const page = useAppSelector(selectFeedbackPage);
  const navigate = useNavigate();

  const { data: feedbackList, isLoading } = useGetFeedbackQuery({ page: 0 });
  const [getFeedbackList] = settingsApiSlice.useLazyGetFeedbackQuery();

  const updateFeedbackList = async () => {
    try {
      await getFeedbackList({ page });
    } catch (error) {
      console.error('Fail to get Feedback', error);
    }
  };

  useEffect(() => {
    updateFeedbackList();
  }, [page]);

  useEffect(() => {
    dispatch(feedbackPageChanged(0));
  }, [0]);

  if (isLoading || !feedbackList) return null;

  return (
    <>
      <h2>{FEEDBACK}</h2>
      <p className={cx('fs16', 'tac')}>{FEEDBACK_GUIDE}</p>

      <div className={cx('btn_wrap', 'bottom', 'mx_min')}>
        <button
          type="button"
          className={cx('btn', 'b_t', 's48')}
          onClick={() => navigate('../writing-feedback')}
        >
          <span>{WRITING_FEEDBACK}</span>
        </button>
      </div>

      {feedbackList.length ? (
        <TableBody name="feedback" list={feedbackList} />
      ) : (
        <div className={cx('comment_empty')}>
          <span>{NO_FEEDBACK}</span>
        </div>
      )}
    </>
  );
}
